import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Text,
    Select,
    Flex,
    TabPanel,
    TabPanels,
    Tabs,
    Heading,
    List,
    ListItem,
    ListIcon,
} from '@chakra-ui/react';
import TilesSection from '../../sections/TilesSection/TilesSection';
import './styles.css';
import { useState, useId } from 'react';
import StyledButton from '../../components/Button/Button';
import ImageWithBoxSection from '../../sections/ImageWithBoxSection/ImageWithBoxSection';
import { CheckIcon } from '@chakra-ui/icons';

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611030&ext=.webp',
    alt: 'Uśmiechnięta kobieta korzystająca z laptopa',
};

interface TabItem {
    tabLabel: string;
    tabContent: React.ReactNode;
}

interface TabsComponentProps {
    selectLabel: string;
    tabs: TabItem[];
}

const TabsComponentOpins = ({ selectLabel, tabs }: TabsComponentProps) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const uniqueId = useId();
    const tabsSelectId = `tabs-select-${uniqueId}`;

    return (
        <Box>
            <Tabs
                display={{ base: 'block', md: 'none' }}
                variant="unstyled"
                index={selectedTab}
                onChange={index => setSelectedTab(index)}
            >
                <Box>
                    <Text
                        as={'label'}
                        htmlFor={tabsSelectId}
                        fontSize={'12px'}
                        marginBottom={'5px'}
                        display={'block'}
                    >
                        {selectLabel}
                    </Text>
                    <Select
                        id={tabsSelectId}
                        value={selectedTab}
                        onChange={e => setSelectedTab(Number(e.target.value))}
                        borderRadius="none"
                        borderWidth="0"
                        outlineColor="gray.400"
                        outlineOffset="0"
                        _placeholder={{ color: 'gray.400' }}
                        _focusVisible={{
                            outlineWidth: '2px',
                            outlineStyle: 'solid',
                            outlineColor: 'gray.800',
                            borderColor: 'gray.800',
                            boxShadow: 'none',
                        }}
                        sx={{
                            '& option': {
                                background: 'gray.400',
                                color: 'gray.0',
                            },
                        }}
                    >
                        {tabs.map((tab, index) => (
                            <option key={index} value={index}>
                                {tab.tabLabel}
                            </option>
                        ))}
                    </Select>
                </Box>
                <TabPanels marginTop={'20px'}>
                    {tabs.map((tab, index) => (
                        <TabPanel key={index} padding={0}>
                            {tab.tabContent}
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
            <Box display={{ base: 'none', md: 'block' }}>
                {tabs.map((tab, index) => (
                    <Box key={index}>{tab.tabContent}</Box>
                ))}
            </Box>
        </Box>
    );
};

const tabsConfig = {
    selectLabel: 'Włącz opinie w swoim sklepie:',
    tabs: [
        {
            tabLabel: 'Zaufane Opinie Smile',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611031&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Zaufane Opinie Smile
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Wykorzystaj Zaufane Opinie Smile, zbieraj recenzje od klientów i buduj
                            zaufanie do swojej marki. Smile gwarantuje, że wszystkie opinie są
                            autentyczne, co dodatkowo wzmacnia Twoją wiarygodność.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://www.idosell.com/pl/marketing-internetowy-dla-sklepow-internetowych-idosell/opinie-twoich-klientow-w-sklepie-idosell-inspiracja-dla-ciebie-zrodlo-wiedzy-dla-twoich-klientow/serwis-zaufane-opinie-smile/'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Dowiedz się więcej
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
        {
            tabLabel: 'Opinie Google',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611074&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Opinie
                            <Text as="span" display={{ base: 'none', lg: 'inline' }}>
                                {' '}
                                konsumenckie
                            </Text>{' '}
                            Google
                            <Text as="span" display={{ base: 'none', lg: 'inline' }}>
                                {' '}
                                Shopping
                            </Text>
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Zbieraj opinie bezpośrednio w Google, gdzie klienci mogą oceniać Twoje
                            produkty i usługi. Wysoka ocena na Google to dodatkowa rekomendacja,
                            która może przyciągnąć nowych użytkowników.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://www.idosell.com/pl/marketing-internetowy-dla-sklepow-internetowych-idosell/opinie-twoich-klientow-w-sklepie-idosell-inspiracja-dla-ciebie-zrodlo-wiedzy-dla-twoich-klientow/google-shopping-opinie-konsumenckie-w-twoim-w-sklepie-internetowym/'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Włącz opinie Google
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
        {
            tabLabel: 'Zaufane Opinie Ceneo',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611079&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Zaufane Opinie Ceneo
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Integracja z Ceneo pozwala Ci zbierać i wyświetlać opinie klientów,
                            którzy już dokonali zakupów. Zwiększaj swoją widoczność i przyciągaj
                            nowych użytkowników dzięki wiarygodnym recenzjom na Ceneo.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://www.idosell.com/pl/marketing-internetowy-dla-sklepow-internetowych-idosell/opinie-twoich-klientow-w-sklepie-idosell-inspiracja-dla-ciebie-zrodlo-wiedzy-dla-twoich-klientow/zaufane-opinie-ceneo-w-twoim-sklepie-internetowym/'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Dowiedz się więcej
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
        {
            tabLabel: 'Okazje.info',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611080&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Wiarygodne Opinie Okazje.info
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Okazje.info łączy opinie klientów z realnymi okazjami zakupowymi.
                            Umożliwia użytkownikom dzielenie się opiniami i rzetelną ocenę
                            produktów, pomagając budować zaufanie do Twojego sklepu.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://www.idosell.com/pl/marketing-internetowy-dla-sklepow-internetowych-idosell/opinie-twoich-klientow-w-sklepie-idosell-inspiracja-dla-ciebie-zrodlo-wiedzy-dla-twoich-klientow/wiarygodne-opinie-okazje-info-w-twoim-sklepie-internetowym/'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Włącz integrację
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
        {
            tabLabel: 'Opineo.pl',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611107&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Opineo.pl
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Opineo.pl to jedna z najpopularniejszych platform z opiniami w Polsce.
                            Zbieraj recenzje, które pomogą Ci w budowaniu pozytywnego wizerunku w
                            oczach Twoich klientów.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://www.idosell.com/pl/marketing-internetowy-dla-sklepow-internetowych-idosell/opinie-twoich-klientow-w-sklepie-idosell-inspiracja-dla-ciebie-zrodlo-wiedzy-dla-twoich-klientow/opinie-opineo-pl-w-twoim-sklepie-internetowym/'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Włącz opinie Opineo.pl
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
        {
            tabLabel: 'Trusted Shops',
            tabContent: (
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    py={{ base: '30px', md: '50px', lg: '85px' }}
                    px={{ base: '20px', md: 0 }}
                >
                    <Box
                        margin={{ base: '0 auto 35px', md: '0 35px 0 0', lg: '0 50px 0 0' }}
                        flexShrink={0}
                    >
                        <img
                            src="https://www.idosell.com/panel/file-gate.php?id=611108&ext=.webp"
                            alt="Smile"
                            loading="lazy"
                            width="200px"
                            height="200px"
                            style={{ display: 'block' }}
                        />
                    </Box>
                    <Box>
                        <Text
                            as="strong"
                            marginBottom={'15px'}
                            fontSize={{ base: '30px', lg: '26px' }}
                            fontWeight={600}
                        >
                            Trusted Shops
                        </Text>
                        <Text fontSize={'18px'} marginBottom={'44px'}>
                            Oferuj usługę łatwych i wygodnych zwrotów dzięki współpracy z InPost
                            Paczkomaty. To rozwiązanie buduje zaufanie i zwiększa lojalność
                            klientów.
                        </Text>
                        <Flex>
                            <StyledButton
                                href={
                                    'https://pomoc.idosell.com/marketing-i-promocje/opinie-w-sklepie/trusted-shops'
                                }
                                style={'default'}
                                target="_self"
                            >
                                Dowiedz się więcej
                            </StyledButton>
                        </Flex>
                    </Box>
                </Flex>
            ),
        },
    ],
};

export default function OpinionsPage() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <Box id="opinions">
                <HeroSection
                    title="Opinie w sklepie internetowym"
                    subTitle="Wyróżnij się wiarygodnymi ocenami klientów i buduj reputację oraz zaufanie do swojego sklepu."
                    image={image}
                />
                <div className="homepage containerIdosellPages">
                    <Box
                        margin={{ base: '0 15px', md: 0 }}
                        paddingBottom={{ lg: '100px' }}
                        id="tiles-opins"
                    >
                        <TilesSection
                            title={'Zaufane opinie, które zwiększają sprzedaż'}
                            subtitle={
                                'Buduj zaufanie, zwiększaj sprzedaż i poprawiaj widoczność swojego sklepu dzięki zaufanym opiniom od klientów.'
                            }
                            tiles={[
                                {
                                    title: 'Większa konwersja',
                                    content:
                                        'Im więcej pozytywnych recenzji jest w Twoim sklepie, tym większa szansa, że nowi klienci zdecydują się na zakup.',
                                },
                                {
                                    title: 'Lepsza widoczność w Google',
                                    content:
                                        'Zaufane recenzje wspierają pozycjonowanie Twojego sklepu i produktów.',
                                },
                                {
                                    title: 'Większa lojalność klientów',
                                    content:
                                        'Zadowoleni klienci chętniej wracają do sklepów, które dbają o ich opinie.',
                                },
                                {
                                    title: 'Buduj wiarygodność',
                                    content:
                                        'Opinie w e-sklepie są weryfikowane, co oznacza, że kupujący mogą mieć pewność, że pochodzą od prawdziwych klientów.',
                                },
                            ]}
                        />
                    </Box>
                    <Box paddingBottom={{ base: '90px', lg: '150px' }}>
                        <Box display={{ base: 'block', lg: 'none' }}>
                            <Box
                                margin={'0 -15px'}
                                width={'100vw'}
                                position={'relative'}
                                maxHeight={'300px'}
                                overflow={'hidden'}
                            >
                                <img
                                    src="https://www.idosell.com/panel/file-gate.php?id=611117&ext=.webp"
                                    alt="Kobieta trzymająca smartfon"
                                    loading="lazy"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                                <Text
                                    fontSize={'30px'}
                                    lineHeight={'37px'}
                                    color={'white'}
                                    fontWeight={'600'}
                                    position={'absolute'}
                                    left={'30px'}
                                    bottom={'30px'}
                                    right={'30px'}
                                >
                                    Super Fair Shop. Bezpieczny sklep to większa konwersja
                                </Text>
                            </Box>
                            <Box
                                position={'relative'}
                                padding={'44px 20px'}
                                _before={{
                                    content: '""',
                                    position: 'absolute',
                                    height: '100%',
                                    top: 0,
                                    width: '100vw',
                                    marginLeft: '50%',
                                    left: '-50vw',
                                    zIndex: -2,
                                    backgroundColor: '#1AAC7A',
                                }}
                            >
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color="#171717"
                                >
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <ListIcon as={CheckIcon} mr={'30px'} />
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Wiarygodność potwierdzona certyfikatem
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <ListIcon as={CheckIcon} mr={'30px'} />
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Lepsza konwersja i więcej zamówień
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'} alignItems={'center'}>
                                        <ListIcon as={CheckIcon} mr={'30px'} />
                                        <Box color="white">
                                            <Text as="strong" fontSize={'21px'} fontWeight={600}>
                                                Widoczność i przewaga konkurencyjna
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Box marginTop="35px">
                                    <StyledButton
                                        href={'https://www.idosell.com/pl/superfairshop/'}
                                        style={'default'}
                                        target="_self"
                                    >
                                        Dowiedz się więcej
                                    </StyledButton>
                                </Box>
                            </Box>
                        </Box>
                        <Box display={{ base: 'none', lg: 'block' }}>
                            <ImageWithBoxSection
                                image={{
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=611117&ext=.webp',
                                }}
                                boxSide="right"
                                leftSection={<></>}
                                rightSection={
                                    <Box>
                                        <Text
                                            fontSize={'34px'}
                                            lineHeight={'48px'}
                                            color={'white'}
                                            textAlign={'center'}
                                            mb={'20px'}
                                            fontWeight={'600'}
                                        >
                                            Super Fair Shop. Bezpieczny sklep to większa konwersja
                                        </Text>
                                        <List
                                            spacing={'15px'}
                                            fontSize={'18px'}
                                            lineHeight={'27px'}
                                        >
                                            <ListItem display={'flex'}>
                                                <ListIcon as={CheckIcon} mt="5px" mr={'30px'} />
                                                <Box>
                                                    <Text
                                                        as="strong"
                                                        fontSize={'21px'}
                                                        marginBottom={'5px'}
                                                        fontWeight={600}
                                                    >
                                                        Wiarygodność potwierdzona certyfikatem
                                                    </Text>
                                                    <Text fontSize={'16px'}>
                                                        Szybka finalizacja zakupów z poziomu
                                                        aplikacji mobilnej InPost Mobile
                                                    </Text>
                                                </Box>
                                            </ListItem>
                                            <ListItem display={'flex'}>
                                                <ListIcon as={CheckIcon} mt="5px" mr={'30px'} />
                                                <Box>
                                                    <Text
                                                        as="strong"
                                                        fontSize={'21px'}
                                                        marginBottom={'5px'}
                                                        fontWeight={600}
                                                    >
                                                        Lepsza konwersja i więcej zamówień
                                                    </Text>
                                                    <Text fontSize={'16px'}>
                                                        Kupujący chętniej wybierają sklepy oznaczone
                                                        jako Super Fair Shop, co przekłada się na
                                                        większą sprzedaż i lojalność klientów.
                                                    </Text>
                                                </Box>
                                            </ListItem>
                                            <ListItem display={'flex'}>
                                                <ListIcon as={CheckIcon} mt="5px" mr={'30px'} />
                                                <Box>
                                                    <Text
                                                        as="strong"
                                                        fontSize={'21px'}
                                                        marginBottom={'5px'}
                                                        fontWeight={600}
                                                    >
                                                        Widoczność i przewaga konkurencyjna
                                                    </Text>
                                                    <Text fontSize={'16px'}>
                                                        Certyfikat zwiększa Twoją wiarygodność i
                                                        wyróżnia sklep na tle konkurencji – zarówno
                                                        w oczach klientów, jak i w wynikach
                                                        wyszukiwania.
                                                    </Text>
                                                </Box>
                                            </ListItem>
                                        </List>
                                        <Flex marginTop="35px">
                                            <StyledButton
                                                href={'https://www.idosell.com/pl/superfairshop/'}
                                                style={'default'}
                                                target="_self"
                                            >
                                                Dowiedz się więcej
                                            </StyledButton>
                                        </Flex>
                                    </Box>
                                }
                            />
                        </Box>
                    </Box>
                    <Box paddingBottom={{ base: '55px', lg: '100px' }}>
                        <Box
                            maxWidth={'1100px'}
                            margin={'0 auto 40px'}
                            display={{ base: 'none', md: 'block' }}
                        >
                            <Heading
                                as="h2"
                                fontWeight={600}
                                fontSize={{ base: '25px', lg: '34px' }}
                                lineHeight={{ base: '37px', lg: '48px' }}
                                textAlign={'center'}
                                marginBottom={{ base: '5px', lg: '20px' }}
                            >
                                {'Buduj reputację swojego sklepu'}
                            </Heading>
                            <Text
                                fontSize={{ base: '16px', lg: '18px' }}
                                marginBottom={{ base: '35px', lg: '50px' }}
                                textAlign={'center'}
                            >
                                Opinie klientów są kluczowe dla sukcesu Twojego sklepu
                                internetowego. Dzięki odpowiednim integracjom możesz zbudować
                                zaufanie do swojego biznesu, zdobywając rzetelne opinie z różnych
                                źródeł. Oto narzędzia, które pomogą Ci w budowaniu pozytywnej
                                reputacji:
                            </Text>
                        </Box>
                        <TabsComponentOpins {...tabsConfig} />
                    </Box>
                    <ContactSection pb={1} mb={14} />
                </div>
            </Box>
        </ThemeProvider>
    );
}
